import * as l from "react";
const a = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.534 2.627a3.011 3.011 0 013.682.004l6.764 5.262c1.02.8 1.02 2.353 0 3.154l-.003.002-6.757 5.258a2.997 2.997 0 01-3.691.012l-6.76-5.26-.004-.002a2.007 2.007 0 010-3.154l.003-.002 6.766-5.274zm1.22 1.584L5 9.476a.022.022 0 000 .008l6.756 5.257a.997.997 0 001.226-.005l.006-.005 6.757-5.257V9.47v-.004L12.989 4.21a1.011 1.011 0 00-1.235.002z",
      fill: "#292933"
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.673 12.74l-1.028.934L5 14.956a.023.023 0 000 .008l6.756 5.257a.997.997 0 001.226-.005l.006-.005 6.757-5.257v-.004-.004l-2.156-1.677 1.229-1.578 2.162 1.682c1.02.8 1.02 2.354 0 3.154l-.003.002-6.757 5.258a2.997 2.997 0 01-3.691.012l-6.76-5.26-.004-.002a2.007 2.007 0 010-3.154l.003-.002 1.587-1.237.972-.884 1.346 1.48z",
      fill: "#292933"
    }
  )
), t = a;
export {
  t as default
};
